var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowWarmUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2936_17299",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.5,
    y: 32,
    width: 32,
    height: 32,
    transform: "rotate(180 32.5 32)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2936_17299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.832 24.2333L23.9654 18.1333L25.832 20L16.4987 29.3333L7.16536 20L9.03203 18.1L15.1654 24.2333L15.1654 14.6666L17.832 14.6666L17.832 24.2333ZM17.832 7.99998L17.832 12L15.1654 12L15.1654 7.99998L17.832 7.99998ZM17.832 2.66665L17.832 5.33332L15.1654 5.33332L15.1654 2.66665L17.832 2.66665Z",
    fill: "#343A40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowWarmUp);
export default __webpack_public_path__ + "static/media/arrow_warm_up.996407c1d05450a68c30d7c02fe37d95.svg";
export { ForwardRef as ReactComponent };